export const orgTypeMap = {
  Landlord: { isTest: false, orgType: "Landlord" },
  Tenant: { isTest: false, orgType: "Tenant" },
  "Test Landlord": { isTest: true, orgType: "Landlord" },
  "Test Tenant": { isTest: true, orgType: "Tenant" },
  Funder: { isTest: false, orgType: "Funder" },
  EPC: { isTest: false, orgType: "EPC" },
};
